import { call, put, takeLatest } from "redux-saga/effects";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { v4 as uuidv4 } from "uuid";

import { mucThuKhacTinChiSinhVienApi } from "../../../api/chung-tu/mucThuKhacTinChiSinhVienApi";
import { IMucThuKhacSinhVienSaveHocPhiTinChiRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveHocPhiTinChiRequest";
import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import {
  eMucThuTinChiActionIds,
  IMucThuTinChiActionTypes,
} from "../../action-types/muc-thu/IMucThuTinChiActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { ILopTuNguyenSelectRequest } from "../../../model/request/lop-tin-chi/ILopTuNguyenSelectRequest";
import { IDanhSachLopTinChiSelectByLopTcRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectByLopTcRequest";
import { IMucThuTinChiGanMucThuRequest } from "../../../model/request/chung-tu/IMucThuTinChiGanMucThuRequest";
import { IMucThuTinChiDuyetLopTuNguyenRequest } from "../../../model/request/chung-tu/IMucThuTinChiDuyetLopTuNguyenRequest";
import { NotifyHelper } from "../../../helpers/toast";

export function* mucThuTinChiSaga(): any {
  yield takeLatest(eMucThuTinChiActionIds.LOAD_HOCSINH_START, loadWorker);
  yield takeLatest(eMucThuTinChiActionIds.CALCULATE_START, caculateWorker);
  yield takeLatest(eMucThuTinChiActionIds.SAVE_CALCULATE_START, saveWorker);
  yield takeLatest(
    eMucThuTinChiActionIds.LOAD_MUCTHUKHAC_START,
    loadMucThuWorker,
  );
  yield takeLatest(eMucThuTinChiActionIds.LOAD_LTN_TREE_START, loadLtnTreeWorker);
  yield takeLatest(
    eMucThuTinChiActionIds.LOAD_LTN_SINHVIEN_START,
    loadLtnSinhVienWorker,
  );
  yield takeLatest(eMucThuTinChiActionIds.GAN_MUC_THU_START, ganMucThuWorker);
  yield takeLatest(eMucThuTinChiActionIds.DUYET_LTN_START, duyetLtnWorker);
  yield takeLatest(eMucThuTinChiActionIds.HUYDUYET_LTN_START, huyDuyetLtnWorker);
}

function* loadWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienApi.SelectByLops,
    action.payload as ISinhVienSelectByLopsRequest,
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThuTinChi.LOAD_HOCSINH_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_HOCSINH_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* caculateWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.Caculate,
    action.payload as IDanhSachLopTinChiSelectRequest,
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThuTinChi.CALCULATE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.CALCULATE_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* saveWorker(action: IMucThuTinChiActionTypes): any {
  var req = action.payload as IMucThuKhacSinhVienSaveHocPhiTinChiRequest;
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.SaveCaculate,
    req,
  );
  if (res.is_success) {
    if (req.is_approve) {
      const process_id = uuidv4();
      yield put(
        rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_START({
          payload: res.data as number[],
          process_id,
        }),
      );
    }
    yield put(rootActions.mucThu.mucThuTinChi.SAVE_CALCULATE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.SAVE_CALCULATE_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* loadMucThuWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectVmByLops,
    action.payload as IMucThuKhacSinhVienSelectByLopsRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_MUCTHUKHAC_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_MUCTHUKHAC_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

// ===== Lớp tự nguyện (LTN) =====
function* loadLtnTreeWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.SelectLopTuNguyenTree,
    action.payload as ILopTuNguyenSelectRequest,
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThuTinChi.LOAD_LTN_TREE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_LTN_TREE_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* loadLtnSinhVienWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.SelectSinhVienByLopTc,
    action.payload as IDanhSachLopTinChiSelectByLopTcRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_LTN_SINHVIEN_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_LTN_SINHVIEN_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* ganMucThuWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.GanMucThuLopTuNguyen,
    action.payload as IMucThuTinChiGanMucThuRequest,
  );
  if (res.is_success) {
    NotifyHelper.Success("Gán mức thu thành công");
    yield put(rootActions.mucThu.mucThuTinChi.GAN_MUC_THU_SUCCESS(undefined));
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi");
    yield put(
      rootActions.mucThu.mucThuTinChi.GAN_MUC_THU_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* duyetLtnWorker(action: IMucThuTinChiActionTypes): any {
  const req = action.payload as IMucThuTinChiDuyetLopTuNguyenRequest;
  const process_id = req.process_id ?? uuidv4();
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.DuyetLopTuNguyen,
    req,
    process_id,
  );
  if (res.is_success) {
    NotifyHelper.Success("Duyệt thành công");
    yield put(rootActions.mucThu.mucThuTinChi.DUYET_LTN_SUCCESS(undefined));
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi");
    yield put(
      rootActions.mucThu.mucThuTinChi.DUYET_LTN_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* huyDuyetLtnWorker(action: IMucThuTinChiActionTypes): any {
  const req = action.payload as IMucThuTinChiDuyetLopTuNguyenRequest;
  const process_id = req.process_id ?? uuidv4();
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.HuyDuyetLopTuNguyen,
    req,
    process_id,
  );
  if (res.is_success) {
    NotifyHelper.Success("Hủy duyệt thành công");
    yield put(rootActions.mucThu.mucThuTinChi.HUYDUYET_LTN_SUCCESS(undefined));
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi");
    yield put(
      rootActions.mucThu.mucThuTinChi.HUYDUYET_LTN_ERRR(res.message ?? "Có lỗi"),
    );
  }
}
